<h1 mat-dialog-title i18n>Transfer Request</h1>

<app-info-section [header]="'Request Details'" [details]="requestDetails"></app-info-section>
<app-info-section [header]="'Bike Details'"    [details]="bikeDetails"></app-info-section>
<app-info-section [header]="'User Details'"    [details]="userDetails"></app-info-section>
<app-info-section [header]="'Status Details'"  [details]="statusDetails"></app-info-section>
